import { useState, useEffect, useRef } from 'react';

import './Dropdown.css';

function Dropdown(props) {
	let {
		buttonText,
		buttonIcon,
		buttonIconNode,
		menuItems,
		hideChevron,
		onToggle,
		menuChild,
		className,
		buttonClass,
		menuClass,
	} = props;

	className = className || '';
	buttonClass = buttonClass || '';
	menuClass = menuClass || '';

	const containerRef = useRef(null);
	const menuRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);

	function handleClickOutside(event) {
		if (containerRef.current && !containerRef.current.contains(event.target)) {
			handleToggle(false);
		}
	}

	function handleToggle(open) {
		if (typeof onToggle === 'function') {
			onToggle(open);
		}
		setIsOpen(open);
	}

	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [containerRef]);

	/* Ensure dropdown menu stays within viewport bounds on mobile and desktop */
	useEffect(() => {
		if (!isOpen) return;

		const adjustPosition = () => {
			if (!menuRef.current) return;
			const el = menuRef.current;
			el.style.transform = 'none';

			const rect = el.getBoundingClientRect();
			const pad = 10;
			const viewportWidth = window.innerWidth;

			if (rect.left < pad) {
				const shift = pad - rect.left;
				el.style.transform = `translateX(${shift}px)`;
			} else if (rect.right > viewportWidth - pad) {
				const shift = rect.right - (viewportWidth - pad);
				el.style.transform = `translateX(-${shift}px)`;
			}
		};

		const animId = requestAnimationFrame(adjustPosition);
		return () => cancelAnimationFrame(animId);
	}, [isOpen]);

	let menu = null;

	if (menuItems) {
		menu = menuItems.map((item, i) => {
			if (item.divider) {
				return <div key={i} className="vio-dropdown-divider"></div>;
			}

			return (
				<div
					key={i}
					className={`vio-dropdown-menu-item ${item.className || ''}`}
				>
					<button
						onClick={() => {
							item.onClick();
							handleToggle(false);
						}}
					>
						{item.icon && (
							<span className="vio-dropdown-menu-item-icon">
								<i className={`bi ${item.icon}`} />
							</span>
						)}
						<span>{item.text}</span>
					</button>
				</div>
			);
		});
	} else if (typeof menuChild === 'function') {
		menu = menuChild({ closeDropdown: () => handleToggle(false) });
	} else if (menuChild) {
		menu = menuChild;
	}

	return (
		<div className={`vio-dropdown-container ${className}`} ref={containerRef}>
			<button
				className={`vio-dropdown-button btn btn-primary ${buttonClass} ${
					buttonText ? '' : 'no-text'
				}`}
				onClick={() => handleToggle(!isOpen)}
			>
				{buttonIconNode ? (
					<span className="vio-dropdown-button-icon">{buttonIconNode}</span>
				) : (
					buttonIcon && (
						<span className="vio-dropdown-button-icon">
							<i className={`bi ${buttonIcon}`} />
						</span>
					)
				)}
				<span>{buttonText}</span>
				{!hideChevron && (
					<i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`} />
				)}
			</button>
			{isOpen && (
				<div ref={menuRef} className={`vio-dropdown-menu ${menuClass}`}>
					{menu}
				</div>
			)}
		</div>
	);
}

export default Dropdown;
